import urlTemplate from 'url-template';
import type { Link } from 'src/apis/api-utilities';
import type {
  TsosParams,
  TsosResponse,
} from 'src/apis/transport-auction/types';
import { useAxios } from 'src/hooks/use-axios';

type ExecuteOptions = {
  link: Link;
} & TsosParams;

export function useTsos() {
  return useAxios(
    (axios, baseConfig, { link, ...params }: ExecuteOptions) => {
      const url = urlTemplate.parse(link.href).expand({});
      return axios.request<TsosResponse>({
        ...baseConfig,
        url,
        params,
      });
    },
    { neededOnPageLoad: false }
  );
}

export type TsosRequest = ReturnType<typeof useTsos>;
